import React from "react";
import { Col, Label, FormGroup, Form } from "reactstrap";

export type WebsitePermissionFormViewProps = {
  siteName?: string;
  readOnly: boolean;
  readEdit: boolean;
  readEditPublish: boolean;
  onReadOnlyChange: (checked: boolean) => void;
  onReadEditChange: (checked: boolean) => void;
  onReadEditPublishChange: (checked: boolean) => void;
};

const WebsitePermissionView = ({
  siteName,
  readOnly,
  readEdit,
  readEditPublish,
  onReadOnlyChange,
  onReadEditChange,
  onReadEditPublishChange,
}: WebsitePermissionFormViewProps) => (
  <Col>
    <Form role="form">
      <h3 className="display-3 mb-0">{siteName}</h3>

      <FormGroup className="row">
        <Label className="form-control-label" md="4">Read Only</Label>
        <label className="custom-toggle mr-1">
          <input
            type="checkbox"
            checked={readOnly}
            onChange={(e) => onReadOnlyChange(e.target.checked)}
          />
          <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes" />
        </label>
      </FormGroup>

      <FormGroup className="row">
        <Label className="form-control-label" md="4">Read & Edit</Label>
        <label className="custom-toggle mr-1">
          <input
            type="checkbox"
            checked={readEdit}
            onChange={(e) => onReadEditChange(e.target.checked)}
          />
          <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes" />
        </label>
      </FormGroup>

      <FormGroup className="row">
        <Label className="form-control-label" md="4">Read & Edit & Publish Content</Label>
        <label className="custom-toggle mr-1">
          <input
            type="checkbox"
            checked={readEditPublish}
            onChange={(e) => onReadEditPublishChange(e.target.checked)}
          />
          <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes" />
        </label>
      </FormGroup>
    </Form>
  </Col>
);

export default WebsitePermissionView;
